import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=e8b13d7e&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=e8b13d7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b13d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8b13d7e')) {
      api.createRecord('e8b13d7e', component.options)
    } else {
      api.reload('e8b13d7e', component.options)
    }
    module.hot.accept("./basicInfo.vue?vue&type=template&id=e8b13d7e&scoped=true", function () {
      api.rerender('e8b13d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/productManage/productFrom/basicInfo.vue"
export default component.exports